import React from "react";

const LokalaiInfo = () => {
  return (
    <section className="px-6 py-24 w-full mx-auto text-center bg-black">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-4xl font-semibold text-text mb-2">Lokalai</h2>
        <div className="w-16 h-1 bg-red-500 mx-auto mb-8" />

        <div className="space-y-6 text-base text-textGray text-left">
          <p>
            <a href="#" className="text-redlight hover:underline">
              Lokalai is an innovative software as a service (SAAS) company
            </a>{" "}
            that aims to revolutionise the way retail beauty shops, restaurants,
            and their customers interact.
          </p>

          <p>
            The workforce is becoming increasingly mobile. Flexibility is
            critical for companies to meet shifting market demands. Lokalai
            delivers flexible, scalable tech solutions that help small and
            medium retail businesses adapt, grow, and stay profitable in a
            rapidly changing market. .
          </p>

          <p>
            On March 30, 2020,{" "}
            <a href="#" className="text-redlight hover:underline">
              Lokalai was founded in a small office in Woolston, Christchurch.
            </a>
          </p>

          <p>
            Lokalai offers a global platform for{" "}
            <span className="text-redlight">
              {" "}
              online ordering, booking, and loyalty management—combined{" "}
            </span>{" "}
            with powerful marketing tools—to help small and medium-sized
            businesses in industries like hair, beauty, tattoo, massage, and
            restaurants go digital and connect directly with customers via web,
            mobile, and apps.
          </p>
        </div>
      </div>
    </section>
  );
};

export default LokalaiInfo;
